// src/web/client/src/components/activity/messageDisplay.js
// Shared display helpers for this app's own messages (templates on Automations,
// the sent log on Activity, the details dialog). Moved out of pages/Messages.jsx
// when the sent list became part of Activity.
import { format } from 'date-fns';

export function getStatusConfig(messageOrStatus) {
  const status = typeof messageOrStatus === 'string' ? messageOrStatus : messageOrStatus?.status || 'draft';
  if (status === 'sent') return { label: 'Sent', variant: 'default' };
  if (status === 'scheduled') return { label: 'Scheduled', variant: 'outline' };
  return { label: 'Not sent', variant: 'secondary' };
}

export function getMessageDateValue(message) {
  const raw = message.sent_date || message.createdAt || message.updatedAt;
  if (!raw) return null;
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatSentDate(message) {
  const d = getMessageDateValue(message);
  return d ? format(d, 'MMM d, yyyy HH:mm') : null;
}

export function getMessageTypeColor(type) {
  switch (type) {
    case 'thank_you': return 'bg-blue-100 text-blue-700';
    case 'review_request': return 'bg-green-100 text-green-700';
    case 'follow_up': return 'bg-purple-100 text-purple-700';
    case 'vip_upsell': return 'bg-yellow-100 text-yellow-700';
    case 'custom_offer': return 'bg-pink-100 text-pink-700';
    default: return 'bg-gray-100 text-gray-700';
  }
}

export function formatMessageType(type) {
  return type?.split('_').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') || 'Message';
}
